import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=05a9c4bb&scoped=true&lang=pug&"
import script from "./MessagesList.vue?vue&type=script&lang=coffee&"
export * from "./MessagesList.vue?vue&type=script&lang=coffee&"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=05a9c4bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9c4bb",
  null
  
)

component.options.__file = "MessagesList.vue"
export default component.exports